const date = [
  {
    id: 1,
    date: '',
    title: '',
  },
  {
    id: 2,
    date: '2022-05-29',
    title: 'Koniec zgłoszeń',
  },
  {
    id: 3,
    date: '2022-06-01',
    title: 'Kwalifikacja',
  },
  {
    id: 4,
    date: '2022-06-10',
    title: 'BootCamp',
  },
  {
    id: 5,
    date: '2022-06-15',
    title: 'DemoDay',
  },
]

export default date
